import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { LinkAlt } from 'styled-icons/boxicons-regular';
import { Visibility, VisibilityOff } from 'styled-icons/material';
import { Dialog } from '@progress/kendo-react-dialogs';
import BarLoader from 'react-spinners/BarLoader';
import { ShowNotification } from '../../Notifications';
import database, { firebase } from '../../../model/firebase/firebase';
import LocationSearchInput from '../../locationSearch';
import { palette } from '../../../system/styles/styles';
import { fetchDataPostAsync } from '../../../model/axios/fetchs';
import { PlatformExeptions } from '../../../system/utils/extras';
import { AddCompanyContainer } from '../../../system/styles/components/addCompany';

const AddCompany = ({ className }) => {
  const platform = useSelector((state) => state.platform);
  const [state, setState] = useState({
    error: null,
    showMessage: false,
    message: '',
    password: Math.random().toString(30).substring(2, 6) + Math.random().toString(30).substring(2, 6),
    showModal: false,
    CurrentSection: true,
    load: false,
  });

  const [company, setCompany] = useState({
    companyName: '',
    locationName: '',
    onCreate: true,
    data: '',
    companyAbout: '',
    active: true,
    companyEmail: '',
    objectID: '',
    companyLogo: '',
    companyWebsite: '',
    adminName: '',
    companyLine: '',
    companyPhone: '',
    companyEmployeesNumber: 0,
    campusSegment: '',
    companyRFC: '',
    companyAddressProof: '',
    authTime: dayjs().valueOf(),
  });

  const bodyMailNotification = (pass, destiny, name, adminName) =>
    platform.customEmails
      ? {
          fromEmail: `${platform.fromEmail}`,
          destiny: `${destiny}`,
          subject: `${name} registro exitoso para la bolsa de trabajo de ${PlatformExeptions(platform.platformName)}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola ${adminName},</p>
            <br />
            <p style="font-size: 18px;">Ya puedes publicar vacantes ilimitadas accediendo al
             portal ${platform.platformURL} con el usuario <strong>${destiny}</strong> y 
             la contraseña <strong>${pass}</strong>. (Al iniciar sesion no olvides seleccionar el tipo "Empresa")</p>
             <br />
             <p style="font-size: 18px;">Si tiene dudas sobre el uso o la plataforma puedes contactarte
              con el administrador: ${platform.platformContact}.</p>
            <br />
             <p style="font-size: 18px;">Te deseamos mucho éxito y esperamos encuentres 
             colaboradores que encajen con tu compañía.</p>
             <br />
            <img width="160px" src=${platform.customEmailsLogo} />
            <br />
            <p style="font-size: 14px;">¿Ya nos sigues?</p>
            <br />
            ${
              platform.facebookLink &&
              `<a styles="margin: 7px" href=${platform.facebookLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                </a>`
            }
           ${
             platform.twitterLink &&
             `<a styles="margin: 7px" href=${platform.twitterLink}>
                  <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                </a>`
           }
            ${
              platform.instagramLink &&
              `<a styles="margin: 7px" href=${platform.instagramLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                </a>`
            }
            ${
              platform.linkedinLink &&
              `<a styles="margin: 7px" href=${platform.linkedinLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                </a>`
            }            
            `,
        }
      : {
          destiny: `${destiny}`,
          subject: `${name} registro exitoso para la bolsa de trabajo de ${PlatformExeptions(platform.platformName)}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola ${adminName},</p>
            <br />
            <p style="font-size: 18px;">Ya puedes publicar vacantes ilimitadas accediendo al
             portal ${platform.platformURL} con el usuario <strong>${destiny}</strong> y 
             la contraseña <strong>${pass}</strong>. (Al iniciar sesion no olvides seleccionar el tipo "Empresa")</p>
             <br />
             <p style="font-size: 18px;">Si tiene dudas sobre el uso o la plataforma puedes contactarte
              con el administrador: ${platform.platformContact}.</p>
            <br />
             <p style="font-size: 18px;">Te deseamos mucho éxito y esperamos encuentres 
             colaboradores que encajen con tu compañía.</p>
             <br />
            <img width="140px" src="https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Flogo-dark.37c08620.png?alt=media&token=b1c8657c-4e50-404f-8736-ae15aa0bdd29" />
            <br />
            <p style="font-size: 14px;">¿Ya nos sigues?</p>
            <br />
            <a styles="margin: 7px" href="https://www.facebook.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png">
            </a>
            <a styles="margin: 7px" href="https://twitter.com/lapiezaio?lang=es">
                <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png">
            </a>
            <a styles="margin: 7px" href="https://www.instagram.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png">
            </a>
            <a styles="margin: 7px" href="https://ar.linkedin.com/company/lapieza">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png">
            </a>`,
        };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'password') {
      setState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      setCompany((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleErrors = (error) => {
    let m = '';
    switch (error.code) {
      case 'auth/invalid-email':
        m = 'El correo que proporcionaste no tiene un formato valido, por favor verificalo.';
        break;
      case 'auth/email-already-exists':
        m = 'El correo que proporcionaste esta actualmente en uso';
        break;
      case 'auth/invalid-password':
        m =
          'La contraseña debe de ser de al menos ocho caracteres, por favor introduce una nueva e intantalo de nuevo.';
        break;
      default:
        m = error.code;
        setState((prevState) => ({ ...prevState, message: error.message }));
        break;
    }
    return m;
  };

  const clearInputs = () => {
    setState((prevState) => ({
      ...prevState,
      error: null,
      showMessage: false,
      message: '',
      password: '',
      showPassword: false,
      currentSection: false,
    }));
    setCompany((prevState) => ({
      ...prevState,
      companyName: '',
      locationName: '',
      onCreate: true,
      data: '',
      companyAbout: '',
      active: true,
      companyEmail: '',
      objectID: '',
      companyLogo: '',
      companyWebsite: '',
      companyLine: '',
      companyPhone: '',
      companyEmployeesNumber: 0,
      campusSegment: '',
      adminName: '',
    }));
  };

  const handleSubmit = async () => {
    setState((prevState) => ({
      ...prevState,
      load: true,
    }));
    const { password } = state;
    const { companyEmail } = company;
    const sendable = { email: companyEmail, password, segment: platform.platformName.toLowerCase() };
    const { data = null } = fetchDataPostAsync('company-register', sendable);
    if (data?.code) {
      ShowNotification('error', handleErrors(data), 'Ocurrió un error');
    } else {
      const inc = firebase.firestore.FieldValue.increment(1);
      await database.collection(`${platform.platformName}`).doc('data').update({ companiesCount: inc });
      const sendable = bodyMailNotification(password, companyEmail, company.companyName, company.adminName);
      await fetchDataPostAsync('sendEmailHTML', sendable);
      ShowNotification('success', 'Se registró la empresa exitosamente', '!Listo!');
      clearInputs();
      setState((prevState) => ({
        ...prevState,
        load: false,
      }));
    }
  };

  const togglePassword = () => {
    setState((prevState) => ({ ...prevState, showPassword: !state.showPassword }));
  };

  const returnLatLang = (ll, local) => {
    setCompany((prevState) => ({
      ...prevState,
      locationName: local,
      latlang: { ...ll },
    }));
  };

  const validator = () => {
    const { companyEmail, companyName, adminName } = company;
    const { password } = state;
    if (companyEmail && companyName && adminName && password) {
      if (platform.platformCampus.length > 0) {
        if (company.campusSegment === '') {
          return Promise.resolve(false);
        }
        return Promise.resolve(true);
      }
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  };

  const copyLink = () => {
    const textField = document.createElement('textarea');
    textField.innerText = `${platform.platformURL}/pedir-acceso-empresas`;
    const parentElement = document.getElementById('textcopy');
    parentElement.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    parentElement.removeChild(textField);
    ShowNotification('success', 'Copiado al portapapeles', '');
  };

  const ToggleModal = () => {
    setState((prevState) => ({
      ...prevState,
      showModal: !prevState.showModal,
    }));
  };

  const SubNavigation = (p) => {
    setState((prevState) => ({
      ...prevState,
      CurrentSection: p,
    }));
  };

  return (
    <AddCompanyContainer className={className} adminColor={platform?.adminColor}>
      <div className="mailOptions">
        <p className={state.CurrentSection ? 'navItemActive' : 'navItem'} onClick={() => SubNavigation(true)}>
          Manualmente
        </p>
        <p className={!state.CurrentSection ? 'navItemActive' : 'navItem'} onClick={() => SubNavigation(false)}>
          Compartir link
        </p>
      </div>
      {state.CurrentSection ? (
        <div className="generalSettingsPage">
          <div className="inputBox50">
            <label className="inputLabel" htmlFor="companyName">
              Nombre de la empresa{' '}
            </label>
            <input
              id="companyName"
              type="text"
              name="companyName"
              onChange={handleInputChange}
              className="customInput"
              value={company.companyName}
            />
          </div>
          <div className="inputBox50">
            <label className="customLabel" htmlFor="adminName">
              Nombre del administrador
            </label>
            <input
              id="adminName"
              type="text"
              name="adminName"
              onChange={handleInputChange}
              className="customInput"
              value={company.adminName}
            />
          </div>
          <div className="inputBox50">
            <label className="customLabel">Ubicación</label>
            <LocationSearchInput
              className="customInput"
              class="customInput"
              inputLocation="customInput"
              returnLatLang={returnLatLang}
              prefill={company.locationName}
            />
          </div>
          <div className="inputBox50">
            <label className="customLabel" htmlFor="companyLine">
              Giro de la empresa
            </label>
            <input
              id="companyLine"
              type="text"
              name="companyLine"
              onChange={handleInputChange}
              className="customInput"
              value={company.companyLine}
            />
          </div>
          <div className="inputBox50">
            <label className="customLabel" htmlFor="companyEmployeesNumber">
              Número de empleados
            </label>
            <input
              id="companyEmployeesNumber"
              type="text"
              name="companyEmployeesNumber"
              onChange={handleInputChange}
              className="customInput"
              value={company.companyEmployeesNumber}
            />
          </div>
          <div className="inputBox50">
            <label className="customLabel" htmlFor="companyPhone">
              Teléfono
            </label>
            <input
              id="companyPhone"
              type="text"
              name="companyPhone"
              onChange={handleInputChange}
              className="customInput"
              value={company.companyPhone}
            />
          </div>
          <div className="inputBox50">
            <label className="customLabel" htmlFor="companyEmail">
              {' '}
              Correo electrónico
            </label>
            <input
              type="email"
              id="companyEmail"
              name="companyEmail"
              onChange={handleInputChange}
              className="customInput"
              value={company.companyEmail}
            />
          </div>
          <div className="togglePasswordContainer">
            <label htmlFor="password" className="customLabel">
              Contraseña
            </label>
            <input
              id="password"
              className="customInput"
              type={state.showPassword ? 'text' : 'password'}
              value={state.password}
              name="password"
              onChange={handleInputChange}
              required
            />
            {state.showPassword ? (
              <Visibility size={20} color="gray" onClick={togglePassword} className="togglePassword" />
            ) : (
              <VisibilityOff size={20} color="gray" onClick={togglePassword} className="togglePassword" />
            )}
          </div>
          {platform.platformCampus.length > 0 ? (
            <div className="inputBox50">
              <label className="customLabel">Campus / Sede asociado</label>
              <select
                name="campusSegment"
                className="customInput"
                value={company.campusSegment}
                onChange={handleInputChange}>
                <option value="" key="" disabled defaultValue hidden>
                  Campus / Sedes registradas
                </option>
                {platform.platformCampus.map((campus) => (
                  <option value={campus} key={campus}>
                    {campus}
                  </option>
                ))}
              </select>
            </div>
          ) : null}
          <div className="inputBox50">
            <label htmlFor="companyDescription" className="inputLabel">
              Descripción de la empresa
            </label>
            <textarea
              className="customInput"
              id="companyDescription"
              name="data"
              onChange={handleInputChange}
              rows="3"
              value={company.data}
              style={{ resize: 'none' }}
            />
          </div>
          <div className="a-form-button">
            <button
              className="saveCompany"
              onClick={() => {
                validator().then((valid) => {
                  if (valid) {
                    handleSubmit();
                  } else {
                    ShowNotification('warning', 'Debes de llenar los campos', '');
                  }
                });
              }}>
              Agregar empresa
            </button>
          </div>
        </div>
      ) : (
        <div className="generalSettingsPage">
          <p className="send-link-title">
            {`Comparte este link con la empresa que deseas agregar. 
                Una vez que complete su solicitud, es necesario aceptarla en la sección de “Empresas” > “Pendientes”`}
          </p>
          <p className="link-to-register-form" id="textcopy" onClick={copyLink}>
            <LinkAlt size={20} color="#CCC" />
            {`${platform.platformURL}/pedir-acceso-empresas`}
          </p>
        </div>
      )}
      {state.load ? (
        <Dialog className="backdrop">
          <BarLoader sizeUnit="px" size={750} color={palette.blue} />
          <p>Procesando ...</p>
        </Dialog>
      ) : null}
    </AddCompanyContainer>
  );
};
export default AddCompany;
